<div class="coding-suggestions" [class.disabled]="disabled">
  <button type="button" class="field-action-link"
    (click)="toggleCodingSuggestions($event)"
    title="View coding suggestions"
    [disabled]="disabled || codingSuggestionsLoading && showPanel">
    <span class="sparkle-icon" aria-hidden="true"></span>
    {{ label }}
  </button>

  <div class="coding-suggestion-panel" *ngIf="showPanel" (click)="$event.stopPropagation()">

    <div class="panel-header">
      <div class="panel-header-left">
        <span class="panel-ai-badge">
          <span class="panel-ai-badge-dot"></span>AI
        </span>
        <span class="panel-title">Suggested account</span>
      </div>
      <button type="button" class="panel-close" aria-label="Close" (click)="closeCodingSuggestionsPanel($event)">&times;</button>
    </div>

    <div class="panel-body">

      <!-- Loading -->
      <div class="panel-state loading" *ngIf="codingSuggestionsLoading">
        <mat-spinner diameter="16"></mat-spinner>
        <span>Analysing invoice…</span>
      </div>

      <!-- Error -->
      <div class="panel-state error" *ngIf="!codingSuggestionsLoading && codingSuggestionsError">
        <span>{{ codingSuggestionsError }}</span>
        <button type="button" class="retry-btn" (click)="reloadCodingSuggestions($event)">Try again</button>
      </div>

      <ng-container *ngIf="!codingSuggestionsLoading && !codingSuggestionsError && codingSuggestions">

        <!-- Empty -->
        <div class="panel-state empty" *ngIf="!codingSuggestions.allSuggestions?.length">
          No suggestions yet. Code a few more invoices from this supplier to improve accuracy.
        </div>

        <ng-container *ngIf="codingSuggestions.allSuggestions?.length">

          <!-- Top suggestion card -->
          <div class="top-suggestion">
            <div class="top-suggestion-label">Best match</div>
            <div class="ai-account-name">{{ codingSuggestions.aiSuggestion?.accountName || 'Unknown account' }}</div>
            <div class="ai-card-meta">
              <span class="ai-code-badge" *ngIf="codingSuggestions.aiSuggestion?.accountCode">{{ codingSuggestions.aiSuggestion.accountCode }}</span>
              <span class="ai-confidence" *ngIf="codingSuggestions.aiSuggestion?.confidence != null">
                {{ codingSuggestions.aiSuggestion.confidence | number:'1.0-0' }}% match
              </span>
            </div>
            <p class="ai-reason" *ngIf="codingSuggestions.aiSuggestion?.reasoning">{{ codingSuggestions.aiSuggestion.reasoning }}</p>
            <div class="apply-row">
              <button type="button" class="apply-btn" (click)="applySuggestedAccount()">
                Use this account
              </button>
              <button type="button" class="feedback-btn"
                title="Suggestion not helpful"
                aria-label="Give feedback on this suggestion"
                (click)="toggleFeedback(codingSuggestions.aiSuggestion, $event)">
                <i class="far fa-thumbs-down"></i>
              </button>
            </div>
            <div class="feedback-form"
              *ngIf="feedbackOpenId && feedbackOpenId === feedbackKey(codingSuggestions.aiSuggestion)">
              <textarea class="feedback-input"
                placeholder="What was wrong with this suggestion? (optional)"
                rows="2"
                [(ngModel)]="feedbackNote"
                [disabled]="feedbackSubmitting"></textarea>
              <div class="feedback-actions">
                <button type="button" class="feedback-cancel" (click)="cancelFeedback($event)"
                  [disabled]="feedbackSubmitting">Cancel</button>
                <button type="button" class="feedback-submit"
                  (click)="submitFeedback(codingSuggestions.aiSuggestion, $event)"
                  [disabled]="feedbackSubmitting">
                  {{ feedbackSubmitting ? 'Sending…' : 'Send feedback' }}
                </button>
              </div>
            </div>
          </div>

          <!-- Other suggestions list -->
          <ng-container *ngIf="codingSuggestions.allSuggestions.length > 1">
            <div class="other-label">Other suggestions</div>
            <div class="other-list">
              <ng-container *ngFor="let s of codingSuggestions.allSuggestions | slice:1">
                <div class="other-row"
                  [class.has-reason]="!!s.reasoning"
                  [class.expanded]="isOtherExpanded(s)"
                  (click)="s.reasoning && toggleOtherSuggestion(s, $event)"
                  [attr.role]="s.reasoning ? 'button' : null"
                  [attr.title]="s.reasoning ? 'Show reasoning' : null">
                  <div class="other-row-info">
                    <span class="other-row-name">
                      <i class="fas fa-chevron-right other-row-chevron" *ngIf="s.reasoning"></i>
                      {{ s.accountName || 'Unknown account' }}
                    </span>
                    <div class="other-row-meta">
                      <span class="ai-code-badge sm" *ngIf="s.accountCode">{{ s.accountCode }}</span>
                      <span class="other-row-confidence" *ngIf="s.confidence != null">{{ s.confidence | number:'1.0-0' }}%</span>
                    </div>
                  </div>
                  <div class="other-row-actions" (click)="$event.stopPropagation()">
                    <button type="button" class="other-use-btn" (click)="applySpecificSuggestion(s)">Use</button>
                    <button type="button" class="feedback-btn sm"
                      title="Suggestion not helpful"
                      aria-label="Give feedback on this suggestion"
                      (click)="toggleFeedback(s, $event)">
                      <i class="far fa-thumbs-down"></i>
                    </button>
                  </div>
                </div>
                <div class="other-row-reason" *ngIf="isOtherExpanded(s) && s.reasoning">
                  {{ s.reasoning }}
                </div>
                <div class="feedback-form inline"
                  *ngIf="feedbackOpenId && feedbackOpenId === feedbackKey(s)">
                  <textarea class="feedback-input"
                    placeholder="What was wrong with this suggestion? (optional)"
                    rows="2"
                    [(ngModel)]="feedbackNote"
                    [disabled]="feedbackSubmitting"></textarea>
                  <div class="feedback-actions">
                    <button type="button" class="feedback-cancel" (click)="cancelFeedback($event)"
                      [disabled]="feedbackSubmitting">Cancel</button>
                    <button type="button" class="feedback-submit"
                      (click)="submitFeedback(s, $event)"
                      [disabled]="feedbackSubmitting">
                      {{ feedbackSubmitting ? 'Sending…' : 'Send feedback' }}
                    </button>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>

        </ng-container>
      </ng-container>

    </div>
  </div>
</div>
